import { Flex, Inline } from "PFComponents/containers";
import { TooltipIcon } from "PFComponents/tooltip";
import { Activity, Id } from "PFTypes";
import { Link } from "react-router";
import { useLocation } from "react-use";

import { NotificationItem } from "./notification_item";

type Notification = {
  id: Id;
  body: string;
  status: string;
  created_at: string;
  title: string;
  category_type: string;
};

type ActivityNameCellProps = {
  item: Activity & { notifications?: Notification[] };
};

export const ActivityNameCell = ({ item }: ActivityNameCellProps) => {
  const { search } = useLocation();

  const hasNotifications = (item.notifications || []).length > 0;

  const tooltipContent = hasNotifications && (
    <Flex direction="column" gap="spacingLg">
      {item.notifications?.map((notification) => (
        <NotificationItem key={notification.id} notification={notification} />
      ))}
    </Flex>
  );

  return (
    <Inline alignItems="center">
      <Link
        to={{
          pathname: `/activities/${item.id}`,
          search
        }}
        state={{ utmSource: "workflow" }}
        data-qa-id={`WorkflowPageRowActivityLink.${item.id}`}
      >
        {item.name}
      </Link>
      {tooltipContent && (
        <TooltipIcon content={tooltipContent} tooltipProps={{ placement: "bottom-start" }} />
      )}
    </Inline>
  );
};
